<template>
    <div class="ml-2 appraisal-autocomplete-input">
        <label
            class="d-block font-weight-bold mb-1"
            for="appraisalSearch">
            Gutachten suchen
        </label>
        <AutocompleteInput
            id="appraisalSearch"
            v-model="searchTerm"
            :delay="500"
            :fetch-url="fetchUrl"
            :map-results="mapResults"
            :min-length="3"
            @selected="handleSelected"/>
    </div>
</template>

<script>
import AutocompleteInput from '@desktop/components/formelements/AutocompleteInput.vue';

export default {
    name: 'AppraisalAutocompleteInput',
    components: {AutocompleteInput},
    props: {
        emailId: {type: String, required: true},
    },
    emits: ['selected'],
    data() {
        return {
            searchTerm: '',
        };
    },
    computed: {
        fetchUrl() {
            return '/api/desktop/digital-mailbox/emails/'
                + this.emailId
                + '/damage-record-assignments/search-appraisals?term=';
        },
    },
    methods: {
        mapResults(resultRows) {
            return resultRows.map(resultRow => {
                const attributesData = resultRow.attributes || resultRow;

                return {
                    value: attributesData.label,
                    text: attributesData.label,
                    raw: {id: resultRow.id, ...attributesData},
                };
            });
        },
        handleSelected(selectedData) {
            this.$emit('selected', selectedData);
        },
    },
};
</script>
